"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
const utils_1 = require("../utils");
exports.default = new class FilenameComponent extends component_1.default {
    defaultOptions = { basename: true, extension: true, color: "red", bold: true };
    get(options) {
        let filepath = (0, utils_1.getStack)()[3]?.getFileName();
        if (options.base && filepath.startsWith(options.base))
            filepath = filepath.slice(options.base.length);
        if (options.basename)
            filepath = filepath.split(/[/\\]/).at(-1) || "";
        filepath ||= "??.js";
        if (!options.extension) {
            const extIndex = filepath.lastIndexOf(".");
            if (extIndex !== -1) {
                filepath = filepath.slice(0, extIndex);
            }
        }
        return filepath;
    }
    ;
};
